import { Box, Button, IconButton, Link, Sheet, Table, Typography } from "@mui/joy";
import useAddEntryForm from "../../hooks/useAddEntryForm";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

const OtherAttachments = ({ formData, isReadOnly, handleFileChange, handleFileClick, btsNo, onHandleDeleteRow }) => {
    const { sectionHeaderStyles, onUploadedFileClick } = useAddEntryForm();
    const location = useLocation();
    const urls = location?.pathname?.split("/");
    const isView = urls?.includes("view-invoice-entry") || urls?.includes("approver-page");
    const isGEMInvoiceVisible = formData?.gem_type === "GEM";
    const [size, setSize] = useState<any>([{}]);

    useEffect(() => {
        if (formData.othersAttachments.length > 0) {
            setSize([...formData.othersAttachments]);
        }
    }, [formData.othersAttachments])

    const handleAddRow = () => {
        if (formData.othersAttachments.length < size.length) {
            toast.error("Add first empty attachment field.")
        } else {
            setSize([...size, {}]);
        }
    }

    // return (<></>)
    return (
        <>
            <Sheet variant="outlined" sx={{ p: 0, borderRadius: "sm", overflow: "hidden" }}>
                {btsNo !== 11 && (
                    <Typography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
                        Other Attachments
                        {(size.length < 5 && !isView) && <Button size="sm" style={{ float: 'right' }} onClick={handleAddRow}>
                            <Add />
                        </Button>}
                    </Typography>
                )}
                <Box sx={{ overflowX: "auto" }}>
                    <Table
                        borderAxis="bothBetween"
                        stickyHeader
                        sx={{
                            "& tr > *:not(:first-child)": { textAlign: "center" },
                        }}
                    >
                        <tbody>
                            {
                                !isView && size.map((item, index) => {
                                    return (
                                        <tr key={'87654' + index}>
                                            <td>
                                                <Typography level="body-xs" sx={{ mt: 1, color: "text.secondary" }}>
                                                    Max File Size (5 MB). Only PDF files are accepted.
                                                </Typography>
                                                <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                                                    Special character is not allowed in name of scanned sign copy in PDF form.
                                                </Typography>
                                            </td>
                                            <td style={{ justifyContent: "center", alignItems: "center", minHeight: "max-content" }}>
                                                {!isReadOnly ? (
                                                    <Button component="label" sx={{ maxWidth: "fit-content" }} variant="outlined" size="sm" startDecorator={<CloudUploadIcon />}>
                                                        Choose File
                                                        <input type="file" name="attachment" hidden onChange={(e: any) => handleFileChange(e, index)} accept="application/pdf" />
                                                    </Button>
                                                ) : (
                                                    <Typography level="body-xs" textColor="text.tertiary">
                                                        {item?.existingAttachmentName ?? (item?.file_data instanceof File ? "New file selected" : "Not provided")}
                                                    </Typography>
                                                )}
                                                {item?.file_data && (
                                                    <Link onClick={() => onUploadedFileClick(item?.attachmentPreview)} level="body-xs" sx={{ mt: 0.5, display: "block" }}>
                                                        {item?.file_name}
                                                    </Link>
                                                )}
                                            </td>
                                            <td>
                                                {(!item?.existingAttachmentName && item?.file_key) ? (
                                                    <Link onClick={() => handleFileClick(item.file_key, btsNo, true)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                                                        View/Download
                                                    </Link>
                                                ) : (
                                                    <Typography level="body-xs" textColor="text.tertiary">
                                                        No File uploaded
                                                    </Typography>
                                                )}
                                            </td>
                                            <td>
                                                {(index > 0) && <IconButton size="sm" color="danger" variant="plain" onClick={() => onHandleDeleteRow(index)}>
                                                    <DeleteIcon />
                                                </IconButton>}
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                            {isView && size.map((item, index) => {
                                return <tr>
                                    <td>{item.file_key && <Typography level="body-sm">{item.file_key}</Typography>}</td>
                                    <td style={{ justifyContent: "center", alignItems: "center", minHeight: "max-content" }}>
                                        <Typography level="body-xs" textColor="text.tertiary">
                                            {item?.file_name || "Not provided"}
                                        </Typography>
                                    </td>
                                    <td>
                                        {item?.file_name ? (
                                            <Link onClick={() => handleFileClick(item.file_key, btsNo, true, item.file_key)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                                                View/Download
                                            </Link>
                                        ) : (
                                            <Typography level="body-xs" textColor="text.tertiary">
                                                No File uploaded
                                            </Typography>
                                        )}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Box>
            </Sheet>
        </>
    );
};

export default OtherAttachments;
